import { useTranslation } from 'react-i18next';
import { Button, Modal } from 'antd';

/**
 * Asked when leaving a profile tile with unsaved changes: Save / Discard /
 * Stay. Props come from useProfileTileSwitch's `leavePrompt`.
 */
export default function ProfileLeaveTileModal({
  open,
  saving,
  tileLabel,
  onSave,
  onDiscard,
  onStay,
}) {
  const { t } = useTranslation('translations');
  const tp = (key, opts) => t(`employeeProfile.${key}`, opts);

  return (
    <Modal
      open={open}
      title={tp('unsavedTile')}
      onCancel={saving ? undefined : onStay}
      closable={!saving}
      maskClosable={!saving}
      centered
      footer={
        <div className="flex justify-end gap-2">
          <Button
            className="btn-default btn-default--hover"
            disabled={saving}
            onClick={onStay}
          >
            {tp('leaveTileStay')}
          </Button>
          <Button
            className="btn-default btn-default--hover"
            disabled={saving}
            onClick={onDiscard}
          >
            {tp('leaveTileDiscard')}
          </Button>
          <Button
            type="primary"
            className="btn-primary"
            loading={saving}
            onClick={onSave}
          >
            {tp('leaveTileSave')}
          </Button>
        </div>
      }
    >
      {tp('leaveTileQuestion', { tile: tileLabel })}
    </Modal>
  );
}
